import type { GameRound, GameState, Trick } from './definitions';
import { RoundStage } from './definitions';
import { createDeck } from './general_utils';

function getDefaultGameState(): GameState {
	return {
		rounds: [],
		currentPlayer: 0,
		score: [],
		roundStage: RoundStage.Deal,
		playerCount: 4,
		deck: createDeck(),
		scoreThreshold: 50,
		heartsBroken: false,
		players: [],
		level: '',
	};
}

export function createGameState(playerCount: number | Partial<GameState> = 4): GameState {
	const defaultGameState = getDefaultGameState();

	if (typeof playerCount !== 'number') {
		return {
			...defaultGameState,
			...playerCount,
		};
	}

	return {
		...defaultGameState,
		playerCount,
	};
}

export function createGameRound(): GameRound {
	return {
		tricks: [],
		score: [],
		moonShooter: null,
		heartPoints: [],
		queenSpadesPoints: [],
		moonPoints: [],
	};
}

export function createTrick(leadPlayer: number): Trick {
	return {
		leadPlayer,
		cardsPlayed: [],
	};
}
